/* Copyright (c) 2022 Paul Nebel */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NumericInput from 'react-numeric-input';

import CFModal from './modal';
import { Mode } from '../core/utils/chord-parser';

import * as styles from '../styles/components.module.css';

NumericInput.style.input.width = '100%';
NumericInput.style.width = '50%';

function SettingsModal({
    modalClass,
    handleModalClassChanged,
    semitoneOffset,
    dispatch,
    mode,
}) {
    const [state, setState] = useState({
        modalClass,
        handleModalClassChanged,
        semitoneOffset,
        mode,
    });

    React.useEffect(
        () =>
            setState((prevState) => {
                return {
                    ...prevState,
                    modalClass,
                    semitoneOffset,
                    mode,
                };
            }),
        [modalClass, semitoneOffset, mode]
    );

    const handleSemitoneOffsetChange = (value) => {
        dispatch({
            type: `SETTING_CHANGED`,
            name: 'semitoneOffset',
            value,
        });
    };

    const handleModeChange = (value) => {
        dispatch({
            type: `SETTING_CHANGED`,
            name: 'mode',
            value,
        });
    };

    return (
        <CFModal title="Settings" {...state}>
            <div className="container">
                <div className="columns is-mobile">
                    <div className="column has-text-right is-half">
                        Semitone Offset:
                    </div>
                    <div className={ `column is-quarter-tablet is-half-mobile ${ styles.semitoneOffsetInput } `}>
                        <NumericInput
                            min={-12}
                            max={12}
                            mobile={true}
                            value={state.semitoneOffset}
                            onChange={handleSemitoneOffsetChange}
                        />
                    </div>
                </div>
                <div className="columns is-mobile">
                    <div className="column has-text-right is-half">Mode:</div>
                    <div className="column is-half">
                        <div className={ `${ styles.radioList } control` }>
                            <label className="radio">
                                <input
                                    type="radio"
                                    name="mode"
                                    className="mr-2 mt-1"
                                    onChange={() =>
                                        handleModeChange(Mode.MAJOR)
                                    }
                                    checked={state.mode === Mode.MAJOR}
                                />
                                Major
                            </label>
                            <label className="radio">
                                <input
                                    type="radio"
                                    name="mode"
                                    className="mr-2"
                                    onChange={() =>
                                        handleModeChange(Mode.MINOR)
                                    }
                                    checked={state.mode === Mode.MINOR}
                                />
                                Minor
                            </label>
                            <label className="radio">
                                <input
                                    type="radio"
                                    name="mode"
                                    className="mr-2"
                                    onChange={() =>
                                        handleModeChange(Mode.MIXED)
                                    }
                                    checked={state.mode === Mode.MIXED}
                                />
                                Mixed
                            </label>
                        </div>
                    </div>
                    <div className="column is-quarter"></div>
                </div>
            </div>
        </CFModal>
    );
}

const mapStateToProps = ({
    semitoneOffset,
    mode,
}) => {
    return {
        semitoneOffset,
        mode,
    };
};

SettingsModal.propTypes = {
    modalClass: PropTypes.string,
    handleModalClassChanged: PropTypes.func,
    semitoneOffset: PropTypes.number,
    mode: PropTypes.number,
    dispatch: PropTypes.func,
};

SettingsModal.defaultProps = {
    modalClass: 'modal',
    handleModalClassChanged: () => {
        /* do nothing */
    },
    semitoneOffset: 0,
    mode: 0,
};

export default connect(mapStateToProps, null)(SettingsModal);
